import VueI18n from "vue-i18n";
import Vue from "vue";

Vue.use(VueI18n, {
  rtl: true
});

const savedLanguage = localStorage.getItem("language") || "es";

const esMessages = require("@/constants/i18n/es/translations.json");
const enMessages = require("@/constants/i18n/en/translations.json");

const i18n = new VueI18n({
  locale: savedLanguage,
  fallbackLocale: "es",
  messages: {
    es: {
      ...esMessages,
      message: esMessages,
      flag: require("@/assets/img/flags/es.svg")
    },
    en: {
      ...enMessages,
      message: enMessages,
      flag: require("@/assets/img/flags/en.svg")
    }
  }
});
// Create VueI18n instance with options
export default i18n;
